import React, { Component } from 'react'
import { connect } from 'react-redux'

import { CustomModal, InputText, Btn } from '../../../../../components'
import * as UsuarioHttp from '../../../../../services/api/https/settings/user.http'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'

class ModalEditarUsuario extends Component {
  constructor(props) {
    super(props)
    const { usuario } = props
    this.state = {
      id: usuario ? usuario.id : null,
      name: usuario ? usuario.name : '',
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.usuario !== this.props.usuario && this.props.usuario) {
      this.setState({
        id: this.props.usuario.id,
        name: this.props.usuario.name,
      })
    }
  }

  onFormContentChange = (name, value) => {
    this.setState({ [name]: value })
  }

  onBtnSalvarClicked = async () => {
    try {
      const { id, name } = this.state
      if (!name || name.trim().length < 3) {
        throw new Error('Nome deve ter no mínimo 3 caracteres')
      }
      const usuario = await UsuarioHttp.editUser(id, name.trim())
      this.props.onModalSave(usuario)
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  render() {
    const { show, onModalClose } = this.props
    const { name } = this.state
    return (
      <CustomModal header="Editar Usuário" isVisible={show} onClose={onModalClose}>
        <form className="p-grid">
          <div className="p-col-12">
            <InputText
              label="Nome :"
              marginTop={10}
              value={name}
              onChange={value => this.onFormContentChange('name', value)}
            />
          </div>
          <div className="p-col-12">
            <Btn onClick={this.onBtnSalvarClicked}>Salvar</Btn>
          </div>
        </form>
      </CustomModal>
    )
  }
}

export default connect()(ModalEditarUsuario)
